<template>
  <div class="section-card">
    <b-row class="help-text">
      <b-col v-if="immediateCharge" class="text-danger">
        Your card will be charged straight away.
      </b-col>
      <b-col v-else>
        Your card won't be charged until your order is ready to go out.
      </b-col>
    </b-row>

    <b-row v-if="loadingStoredCards || !accountLoaded">
      <b-col>
        <loading-spinner data-cy="square-loading-spinner">
          <div slot="title">
            Please wait while we load the Users Stored Cards
          </div>
        </loading-spinner>
      </b-col>
    </b-row>

    <b-row v-if="processing">
      <b-col>
        <loading-spinner data-cy="processing-spinner">
          <div slot="title">
            Please wait while we store the credit card details
          </div>
        </loading-spinner>
      </b-col>
    </b-row>

    <b-row v-if="accountLoaded">
      <b-col>
        <square-payments-user-stored-card-chooser
          v-model="selectedCard"
          :account="account"
          @processing="setProcessing"
          @loading="__loading"
        >
          <template v-slot:stored-card-header>
            <div class="mt-4">
              Select from the Stored cards currently linked to your account or enter a new card details.
            </div>
          </template>
          <template v-slot:stored-card-message>
            &#8203;
          </template>
          <template v-slot:enter-new-card-label>
            Enter another card details
          </template>
        </square-payments-user-stored-card-chooser>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'card-display-square-payments-add-card',
  data: function() {
    return {
      loadingStoredCards: false,
      processing: false
    }
  },
  computed: {
    ...mapState('somnambulistui', ['payer', 'orderOneNow', 'orderId']),
    ...mapGetters('somnambulistui', ['account', 'getSelectedQuantityObject']),
    immediateCharge() {
      return !this.orderId && this.getSelectedQuantityObject.allowOrderNow && this.orderOneNow
    },
    accountLoaded: function() {
      return Object.prototype.hasOwnProperty.call(this.account, 'userid')
    },
    userid: function() {
      return this.account.userid
    },
    selectedCard: {
      get: function() {
        const result = this.payer && Object.prototype.hasOwnProperty.call(this.payer, 'provider')
          ? (this.payer.provider === 'square_payments' ? this.payer.token : '')
          : ''
        return result
      },
      set: function(val) {
        this.processing = true
        if (val === '' || val === 'new') {
          this.squareCardDetails = {}
          // Update payer state to reflect the selection
          this.$store.commit('somnambulistui/SET_PAYER', { provider: 'square_payments', token: 'new' })
          this.processing = false
        }
        else {
          // Update payer state immediately to reflect the selection
          this.$store.commit('somnambulistui/SET_PAYER', { provider: 'square_payments', token: val })

          this.$store.dispatch('square/loadCustomerCards', { userid: this.userid })
            .then(cardDetails => {
              this.squareCardDetails = cardDetails.find(card => card.id === val)
              this.processing = false
              this.$emit('selected-card', { ...this.squareCardDetails, provider: 'square_payments', payerid: val })
            })
        }
      }
    }
  },
  methods: {
    __loading: function(val) {
      // console.log(`Loading stored cards: ${val}`)
      this.loadingStoredCards = val
    },
    setProcessing: function(val) {
      this.processing = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-title {
    margin: 0 0 2em 0;
    width: 100%;
    text-align: center;
  }
  .help-text {
    text-align: center;
    padding-bottom: 2em;
    border-bottom: 1px solid var(--main-border-color);
  }
</style>
